"use strict";

function e(e) {
  return e && "object" == typeof e && "default" in e ? e.default : e;
}

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var t = require("@chakra-ui/layout"),
    n = require("@chakra-ui/spinner"),
    r = e(require("@laliga-cdac/card")),
    a = require("@chakra-ui/react"),
    l = require("react"),
    o = e(l),
    c = require("@chakra-ui/icons");

function i(e, t) {
  if (null == e) return {};
  var n,
      r,
      a = {},
      l = Object.keys(e);

  for (r = 0; r < l.length; r++) {
    t.indexOf(n = l[r]) >= 0 || (a[n] = e[n]);
  }

  return a;
}

var u = function u(e, t) {
  return void 0 === t && (t = !0), (n = e) && "string" == typeof n ? "unknown.png" === e ? "https://storageprodmzapp.blob.core.windows.net/assets/escudos/" + e : t ? e : "https://storageprodmzapp.blob.core.windows.net/assets/escudos/" + e : "";
  var n;
},
    s = ["fullUrl", "onChange", "selected"],
    d = function d(e) {
  var t = e.fullUrl,
      n = e.onChange,
      r = e.selected,
      d = i(e, s),
      p = l.useRef(null);
  return o.createElement(a.Box, {
    maxWidth: "25%",
    display: "block",
    flex: "0 0 25%"
  }, o.createElement(a.HStack, {
    alignItems: "center",
    justifyContent: "space-between",
    cursor: "pointer",
    onClick: function onClick() {
      return n(d);
    },
    paddingEnd: "9",
    "data-testid": "select-team-button-test-id"
  }, o.createElement(a.HStack, null, o.createElement(a.Image, {
    h: "32px",
    src: u(d.shieldUrl || "unknown.png", t),
    ref: p,
    onError: function onError() {
      var e;
      null != (e = p.current) && e.src && (p.current.src = u("unknown.png"));
    }
  }), o.createElement(a.Text, {
    whiteSpace: "nowrap",
    fontWeight: r ? "bold" : "",
    isTruncated: !0
  }, d.name)), r && o.createElement(c.CheckIcon, {
    color: "corporateBlue.500",
    "data-testid": "selected-icon-test-id"
  })));
},
    p = ["data", "onChange", "isLoading", "isCard", "fullUrl", "color"];

exports.default = function (e) {
  var c = e.data,
      u = e.onChange,
      s = e.isLoading,
      f = e.fullUrl,
      g = e.color,
      m = void 0 === g ? "corporateBlue.100" : g,
      h = i(e, p),
      w = l.useState(),
      k = w[0],
      x = w[1];
  return s ? o.createElement(t.Flex, {
    w: "full",
    p: "50px",
    justifyContent: "center"
  }, o.createElement(n.Spinner, {
    thickness: "4px",
    speed: "0.65s",
    emptyColor: "gray.200",
    color: m,
    size: "xl",
    "data-testid": "spinner-test-id"
  })) : o.createElement(r, {
    cardLineColor: m
  }, o.createElement(t.Flex, Object.assign({
    w: "full",
    flexFlow: "row wrap",
    gridRowGap: "2",
    p: "4"
  }, h), null != c && c.length ? null == c ? void 0 : c.map(function (e) {
    return o.createElement(d, Object.assign({
      selected: (t = e, t.id === (null == k ? void 0 : k.id)),
      onChange: function onChange(e) {
        u(e), x(e);
      },
      key: e.id,
      fullUrl: !!f
    }, e));
    var t;
  }) : o.createElement(a.Text, {
    p: "8",
    w: "full",
    textAlign: "center"
  }, h.fallback || "No data")));
};